<template>
	<World v-if="gameType == 'worldquiz'"/>
	<ImpactCalculator v-else-if="gameType == 'impactcalculator'"/>
	<MBTIprofile v-else-if="gameType == 'mbtiprofile'"/>
	<TeamRole v-else-if="gameType == 'teamrole'"/>
	<Default v-else/>
</template>

<script>

	import World from './world/Index.vue';
	import ImpactCalculator from './impactcalculator/Index.vue';
	import MBTIprofile from './mbtiprofile/Index.vue';
	import TeamRole from './teamrole/Index.vue';
	import Default from './default/Index.vue';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		components:{
			Default,
			World,
			ImpactCalculator,
			MBTIprofile,
			TeamRole,
		},

		computed:{
			gameType(){
				return this.roundData.gametype;
			},

			...mapGetters([
				'roundData',
			]),
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/feedback/Index.vue